import cx from 'clsx'
import React, { DetailedHTMLProps, FormHTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IFormProps
  extends DetailedHTMLProps<
    FormHTMLAttributes<HTMLFormElement>,
    HTMLFormElement
  > {
  bgColor?: 'grey' | 'white'
  align?: 'center' | 'start' | 'end' | 'between'
  direction?: 'row' | 'col'
}

const Form = ({
  bgColor,
  align,
  direction,
  children,
  className,
  ...rest
}: IFormProps) => {
  const classes = cx(
    bgColor && cn[bgColor],
    align && cn[align],
    direction && cn[direction],
    className,
  )
  return (
    <form {...rest} className={classes}>
      {children}
    </form>
  )
}

export default Form
